// API service for Metro Plumbing & Heating backend

const BASE_URL = 'https://08t7k7gx49.execute-api.eu-west-2.amazonaws.com/prod/v1';

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'API request failed');
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const api = {
  // Validate token
  validateToken: (token) => {
    return apiCall('/validate/token', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Login
  login: (username, password) => {
    return apiCall('/login', {
      method: 'POST',
      body: JSON.stringify({ username, password }),
    });
  },

  // Get member details
  getMember: (token) => {
    return apiCall('/member', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Request password reset code
  requestResetCode: (username, email) => {
    return apiCall('/code', {
      method: 'POST',
      body: JSON.stringify({ username, email }),
    });
  },

  // Reset password
  resetPassword: (username, email, code, newPassword) => {
    return apiCall('/password/reset', {
      method: 'POST',
      body: JSON.stringify({ username, email, code, password: newPassword }),
    });
  },

  // Get all requests
  getRequests: (token) => {
    return apiCall('/requests', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  // Submit quote request
  submitQuoteRequest: (data) => {
    return apiCall('/request/quote', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Submit emergency request
  submitEmergencyRequest: (data) => {
    return apiCall('/request/emergency', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Get Google Business reviews
  getGoogleReviews: () => {
    return apiCall('/reviews/google', {
      method: 'GET',
    });
  },
};
